import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-gateway',
  templateUrl: './delete-gateway.component.html',
  styleUrls: ['./delete-gateway.component.scss']
})
export class DeleteGatewayComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<DeleteGatewayComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string, content: string },
  ) { }
  ngOnInit(): void {
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit() {
    this.dialog.close(true);
  }
}
